// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2Qvpe","emails":"CreateEditClinics_emails__3c3jZ","emailTagLabel":"CreateEditClinics_emailTagLabel__2f6MD"};